(function ($) {

	if ($('.section--slider-4__wrapper .slides-image-wrapper .slider-wrapper').length) {
    const wrappers = $('.section--slider-4__wrapper .slides-image-wrapper .slider-wrapper');

    wrappers.each(function(){
      const wrapper = $(this);
      const parent = wrapper.closest('.slides-image-wrapper');
      initSlider4(wrapper);

      wrapper.on('afterChange', function (event, slick, nextSlide) {
        updateprogressbar(nextSlide, parent);
      });

      parent.find('.slider-next').click(function (e) {
        e.preventDefault();
        wrapper.slick('slickNext');
      });

      parent.find('.slider-prev').click(function (e) {
        e.preventDefault();
        wrapper.slick('slickPrev');
      });
    });

	}

  function updateprogressbar(nextSlide, wrapper) {

    let index = parseInt(nextSlide) + 1;
    let totalSlide = wrapper.find('.slick-track > div').length;
    let progress = (index*2 / totalSlide) * 100;

    wrapper.find('.slider-progress').width(progress + '%');
    wrapper.find('.slider-current-index').html(index < 10 ? '0' + index : index);
  }

	function initSlider4(wrapper){
    // const width = $(window).width() - wrapper.offset().left;
    // wrapper.css('width', width + 'px');

    wrapper.slick({
      arrows: false,
      dots: false,
      infinite: false,
      slidesToScroll: 1,
      slidesToShow: 1.2,
      // variableWidth: true,
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      mobileFirst: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 620,
          settings: {
            arrows: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          }
        },
        {
          breakpoint: 992,
          settings: {
            arrows: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          }
        },
        {
          breakpoint: 1680,
          settings: {
            arrows: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            adaptiveHeight: true,
          }
        },
      ]
    });
  }

})(jQuery);
